"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareChoices = void 0;
const shuffle_1 = __importDefault(require("lodash/shuffle"));
const fractionToMathML_1 = require("./fractionToMathML");
const taskStore_1 = require("../../../taskStore");
const prepareChoices = (target, distractors, randomize, trialType) => {
    let choices;
    if (!target || distractors.includes(target)) {
        // If target is not present, don't add to options
        choices = [...distractors];
    }
    else {
        choices = [target, ...distractors]; // add target to options
    }
    // set order for yes/no options - yes should always be first
    if (JSON.stringify([...choices].sort()) === JSON.stringify(['yes', 'no'].sort())) {
        choices = ['yes', 'no'];
    }
    // apply required randomization
    switch (randomize) {
        case 'yes':
            choices = (0, shuffle_1.default)(choices);
            break;
        case 'no':
            break;
        case 'at_block_level':
            const previousChoices = (0, taskStore_1.taskStore)().previousChoices;
            // use previous choices if they match current choices, otherwise set new choice order
            if (previousChoices !== null &&
                previousChoices !== undefined &&
                JSON.stringify([...choices].sort()) === JSON.stringify([...previousChoices].sort())) {
                choices = previousChoices;
            }
            else {
                choices = (0, shuffle_1.default)(choices);
                (0, taskStore_1.taskStore)('previousChoices', choices);
            }
            break;
        default:
            // randomize by default
            choices = (0, shuffle_1.default)(choices);
            break;
    }
    const originalChoices = [...choices];
    if (trialType === 'Fraction') {
        (0, taskStore_1.taskStore)('nonFractionSelections', choices);
        choices = choices.map((choice) => (0, fractionToMathML_1.fractionToMathML)(choice));
    }
    // Update session variables
    const correctResponseIdx = trialType === 'Fraction' ? (0, taskStore_1.taskStore)().nonFractionSelections.indexOf(target) : choices.indexOf(target);
    (0, taskStore_1.taskStore)('target', target);
    (0, taskStore_1.taskStore)('correctResponseIdx', correctResponseIdx);
    (0, taskStore_1.taskStore)('choices', choices);
    return {
        target,
        choices,
        originalChoices,
        correctResponseIdx,
    };
};
exports.prepareChoices = prepareChoices;
